import {
  PartnerLocationRangeSchema,
  type PartnerLocationRange as GeneratedPartnerLocationRange
} from '~/services/api/generated'

// Mirrors backend App\Enums\PartnerLocationRange

export type PartnerLocationRange = GeneratedPartnerLocationRange

export const PartnerLocationRange = {
  ONE: PartnerLocationRangeSchema.enum['1'],
  TWO_TO_FIVE: PartnerLocationRangeSchema.enum['2-5'],
  SIX_PLUS: PartnerLocationRangeSchema.enum['6+']
} satisfies Record<string, GeneratedPartnerLocationRange>

export const PartnerLocationRangeValues: readonly GeneratedPartnerLocationRange[] = [
  PartnerLocationRangeSchema.enum['1'],
  PartnerLocationRangeSchema.enum['2-5'],
  PartnerLocationRangeSchema.enum['6+']
]
